import React, { useState, FormEvent } from "react";
import { forgotPassword } from "../../api";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!email) {
      toast.error("Please enter your email.");
      return;
    }

    setLoading(true);
    try {
      await forgotPassword(email);
      toast.success("Reset link has been sent to your email.", {
        autoClose: 1000,
      });
    } catch (err: any) {
      const msg = err?.response?.data?.message || "Something went wrong.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#000",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <form
          onSubmit={handleSubmit}
          className="d-flex flex-column gap-3"
          style={{
            width: "100%",
            maxWidth: "400px",
            color: "#fff",
            padding: "20px",
          }}
        >
          <h3 className="text-center">Forgot Password</h3>

          <div className="form-group">
            <input
              type="email"
              className="form-control bg-dark text-white border-secondary"
              placeholder="Enter your registered email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="main-btn btn-hover mt-2"
            disabled={loading}
            style={{
              borderRadius: "100px",
              background:
                "linear-gradient(to right,rgb(255, 101, 163),rgb(254, 163, 52))",
            }}
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </button>

          <p className="text-center mt-3">
            <button
              type="button"
              onClick={() => navigate("/login")}
              className="btn btn-link text-white"
              style={{ textDecoration: "underline" }}
            >
              Back to Login
            </button>
          </p>
        </form>
      </div>

      <ToastContainer />

      <div
        className="copyright-footer"
        style={{
          color: "#fff",
          textAlign: "center",
          padding: "10px 0",
        }}
      >
        © {new Date().getFullYear()}, Eventox. All rights reserved.
      </div>
    </div>
  );
};

export default ForgotPassword;
